import React from 'react'
import { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import PrincipalePage from './Pages/Principale/PagePrincipale'
import GalleryPhotos from './Pages/Photos/GalleryPhotos'
import Videos from './Pages/Principale/Videos'
// import FormAdmin from './Pages/FormulaireAdmin/FormAdmin';
import FormAdminActualite from './Pages/FormulaireAdmin/FormActualite'
import FormAdminEvenement from './Pages/FormulaireAdmin/FormEvenement'
import FormAdminHorairesTarifs from './Pages/FormulaireAdmin/FormHorairesTarifs'
import '../styles/App.css'

function App() {
  const location = useLocation()

  useEffect(() => {
    // const titles = {
    //   '/': 'Accueil',
    //   '/about': 'À propos',
    //   '/contact': 'Contact',
    // };
    document.title = 'DUO DANSE'
  }, [location])
  return (
    <div>
      <Routes>
        <Route path="/" element={<PrincipalePage />} />
        <Route path="/PhotosPage" element={<GalleryPhotos />} />
        <Route path="/Videos" element={<Videos />} />
        {/* <Route path="/AdminForm" element={<FormAdmin />} /> */}
        <Route path="FormAdminActualite" element={<FormAdminActualite />} />
        <Route path="FormAdminEvenement" element={<FormAdminEvenement />} />
        <Route
          path="FormAdminHorairesTarifs"
          element={<FormAdminHorairesTarifs />}
        />
      </Routes>
    </div>
  )
}

export default App
